// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__c1a {
  width: 100%;
  position: relative;

  background: var(--ring-sidebar-background-color);
  border-radius: var(--ring-border-radius);
  border: 1px solid var(--ring-line-color);

  &:before {
    content: '';
    position: absolute;
    top: -1px;
    right: -1px;
    left: -1px;
    bottom: -1px;

    border: 2px solid transparent;
    transition: border-color ease-in-out 0.3s;
    border-radius: var(--ring-border-radius);

    pointer-events: none;
  }

  &.focused__d6a:not(.collapsed__d83):before {
    border-color: var(--ring-main-hover-color);
  }

  .ruleHeader__b2a {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: calc(var(--ring-unit) * 2);
    /* badge size + paddings */
    height: calc(var(--ring-unit) * 7.25);
  }

  .ruleBody__b3d {
    padding: 0 calc(var(--ring-unit) * 2) calc(var(--ring-unit) * 2) calc(var(--ring-unit) * 2);
  }

  .ruleName__f1f {
    margin: 0;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .chevron__a35 {
    transition: transform ease-in-out 0.3s;

    .collapsed__d83 & {
      transform: rotateZ(-90deg);
    }
  }

  .remove__d72 {
    position: relative;
    height: calc(var(--ring-unit) * 2);
    width: calc(var(--ring-unit) * 2);
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: var(--ring-icon-error-color);
    }

    &:before {
      position: absolute;
      content: '';
      top: calc(var(--ring-unit) * -1);
      right: calc(var(--ring-unit) * -1);
      bottom: calc(var(--ring-unit) * -1);
      left: calc(var(--ring-unit) * -1);
    }
  }

  .badges__c92 {
    display: flex;
    gap: var(--ring-unit);

    .appear__e15 {
      animation: appearanceAnimation__c24 ease-in-out 0.3s;
    }
  }

  .chevron__a35 + .ruleName__f1f {
    margin-left: var(--ring-unit);
  }

  .ruleName__f1f + .badges__c92,
  .ruleName__f1f + .rdIconWrapper__f33,
  .ruleName__f1f + .remove__d72 {
    margin-left: auto;
  }

  .rdIconWrapper__f33 + .badges__c92,
  .rdIconWrapper__f33 + .remove__d72 {
    margin-left: var(--ring-unit);
  }

  .rdIcon__fac {
    color: var(--ring-warning-color);
  }

  .badges__c92 + .remove__d72 {
    margin-left: var(--ring-unit);
  }
}

@keyframes appearanceAnimation__c24 {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/common/base-plugins-rule/base-plugins-rule.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;;EAElB,gDAAgD;EAChD,wCAAwC;EACxC,wCAAwC;;EAExC;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;;IAEZ,6BAA6B;IAC7B,yCAAyC;IACzC,wCAAwC;;IAExC,oBAAoB;EACtB;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mCAAmC;IACnC,0BAA0B;IAC1B,qCAAqC;EACvC;;EAEA;IACE,2FAA2F;EAC7F;;EAEA;IACE,SAAS;;IAET,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;;IAEtC;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,iCAAiC;IACjC,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,mCAAmC;IACrC;;IAEA;MACE,kBAAkB;MAClB,WAAW;MACX,gCAAgC;MAChC,kCAAkC;MAClC,mCAAmC;MACnC,iCAAiC;IACnC;EACF;;EAEA;IACE,aAAa;IACb,qBAAqB;;IAErB;MACE,oDAA+C;IACjD;EACF;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;;IAGE,iBAAiB;EACnB;;EAEA;;IAEE,6BAA6B;EAC/B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".wrapper {\n  width: 100%;\n  position: relative;\n\n  background: var(--ring-sidebar-background-color);\n  border-radius: var(--ring-border-radius);\n  border: 1px solid var(--ring-line-color);\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    left: -1px;\n    bottom: -1px;\n\n    border: 2px solid transparent;\n    transition: border-color ease-in-out 0.3s;\n    border-radius: var(--ring-border-radius);\n\n    pointer-events: none;\n  }\n\n  &.focused:not(.collapsed):before {\n    border-color: var(--ring-main-hover-color);\n  }\n\n  .ruleHeader {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    padding: calc(var(--ring-unit) * 2);\n    /* badge size + paddings */\n    height: calc(var(--ring-unit) * 7.25);\n  }\n\n  .ruleBody {\n    padding: 0 calc(var(--ring-unit) * 2) calc(var(--ring-unit) * 2) calc(var(--ring-unit) * 2);\n  }\n\n  .ruleName {\n    margin: 0;\n\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .chevron {\n    transition: transform ease-in-out 0.3s;\n\n    .collapsed & {\n      transform: rotateZ(-90deg);\n    }\n  }\n\n  .remove {\n    position: relative;\n    height: calc(var(--ring-unit) * 2);\n    width: calc(var(--ring-unit) * 2);\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    span {\n      color: var(--ring-icon-error-color);\n    }\n\n    &:before {\n      position: absolute;\n      content: '';\n      top: calc(var(--ring-unit) * -1);\n      right: calc(var(--ring-unit) * -1);\n      bottom: calc(var(--ring-unit) * -1);\n      left: calc(var(--ring-unit) * -1);\n    }\n  }\n\n  .badges {\n    display: flex;\n    gap: var(--ring-unit);\n\n    .appear {\n      animation: appearanceAnimation ease-in-out 0.3s;\n    }\n  }\n\n  .chevron + .ruleName {\n    margin-left: var(--ring-unit);\n  }\n\n  .ruleName + .badges,\n  .ruleName + .rdIconWrapper,\n  .ruleName + .remove {\n    margin-left: auto;\n  }\n\n  .rdIconWrapper + .badges,\n  .rdIconWrapper + .remove {\n    margin-left: var(--ring-unit);\n  }\n\n  .rdIcon {\n    color: var(--ring-warning-color);\n  }\n\n  .badges + .remove {\n    margin-left: var(--ring-unit);\n  }\n}\n\n@keyframes appearanceAnimation {\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__c1a`,
	"appearanceAnimation": `appearanceAnimation__c24`,
	"focused": `focused__d6a`,
	"collapsed": `collapsed__d83`,
	"ruleHeader": `ruleHeader__b2a`,
	"ruleBody": `ruleBody__b3d`,
	"ruleName": `ruleName__f1f`,
	"chevron": `chevron__a35`,
	"remove": `remove__d72`,
	"badges": `badges__c92`,
	"appear": `appear__e15`,
	"rdIconWrapper": `rdIconWrapper__f33`,
	"rdIcon": `rdIcon__fac`
};
export default ___CSS_LOADER_EXPORT___;
